<div id="grey-overlay-container">
  <div id="grey-overlay"></div>
  <div class="spinner-grow text-primary" role="status">
    <span class="visually-hidden"></span>
  </div>
  <h2 id="spinner-text">Processing...</h2>
</div>